var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff475c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m600 89.062c69.023 0 135.91 13.5 198.84 40.125 60.82 25.734 115.48 62.578 162.45 109.52 46.945 46.945 83.812 101.6 109.52 162.45 26.625 62.93 40.125 129.84 40.125 198.84s-13.5 135.91-40.125 198.84c-25.734 60.82-62.578 115.48-109.52 162.45-46.945 46.945-101.6 83.812-162.45 109.52-62.93 26.625-129.84 40.125-198.84 40.125s-135.91-13.5-198.84-40.125c-60.82-25.734-115.48-62.578-162.45-109.52-46.945-46.945-83.812-101.6-109.52-162.45-26.625-62.93-40.125-129.84-40.125-198.84s13.5-135.91 40.125-198.84c25.734-60.82 62.578-115.48 109.52-162.45 46.945-46.945 101.6-83.812 162.45-109.52 62.93-26.625 129.84-40.125 198.84-40.125m0-89.062c-331.38 0-600 268.64-600 600s268.62 600 600 600 600-268.64 600-600-268.64-600-600-600z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.44 767.39c-24.586 0-44.531-19.945-44.531-44.531v-449.88c0-24.586 19.945-44.531 44.531-44.531s44.531 19.945 44.531 44.531v449.88c0 24.586-19.945 44.531-44.531 44.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.83 897.52c0 27.828-22.562 50.391-50.391 50.391s-50.391-22.562-50.391-50.391 22.562-50.391 50.391-50.391 50.391 22.562 50.391 50.391"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2fbf30ec281dcc666881abdbd9c12fdc.svg";
export { ForwardRef as ReactComponent };